import React from 'react';
import ReactDOM from 'react-dom';
import {PortalApp} from 'portal-core/components/PortalApp';
import config from './config/consumerPortal.default.json5';
import consumerPortalComponents from './consumerPortalComponents';

ReactDOM.render(
  <PortalApp config={config} components={consumerPortalComponents} />, document.getElementById('app')
);
